export default __webpack_public_path__ + "static/media/number-shine-1.0067b321.svg";